module.exports = __webpack_public_path__ + "media/images/lp_v6_sec12_03-acdb33e05b41ec370f1a2995d38be85a.svg";